import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { serviceUris } from '../../../../environments/services';
import { Injectable, inject } from '@angular/core';
import { AuditFilter } from '../models/audit-filter.model';
import { PaginatedAuditResponse } from '../models/paginated-audit.model';
import { AuditTrail } from '../models/auditTrail.model';

export interface AuditActionListResponse {
  data: Array<string>;
  error: Array<string>;
}

export interface LoginNamesResponse {
  data: Array<string>;
  error: Array<string>;
}

export interface AuditExportData {
  auditTrail: AuditTrail[];
}

export interface AuditExportResponse {
  data: AuditExportData;
  error: Array<string>;
}

export interface AuditExportLimitResponse {
  data?: number | string | null;
  error: Array<string>;
}

@Injectable({
  providedIn: 'root'
})
export class AuditService {
  private http = inject(HttpClient);

  /**
   * Fetches list of login names for a dealer
   * @param dealerId
   */
  getLoginNames(dealerId: string): Observable<LoginNamesResponse> {
    const url = `${environment.backOfficeUrl}${serviceUris.getLoginNames}`;
    return this.http.get<LoginNamesResponse>(url, { headers: { dealer: dealerId } });
  }

  /**
   * back office audit trail
   * @param filters
   * @param pageNumber
   * @param pageSize
   * @param localTimeZone
   */
  searchAudit(filters: AuditFilter, pageNumber: number, pageSize: number, localTimeZone: string): Observable<PaginatedAuditResponse> {
    const filteredParams = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value != null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as any);

    const params: any = {
      ...filteredParams,
      page: pageNumber,
      pageSize
    };
    const url = `${environment.backOfficeUrl}${serviceUris.searchAuditList}`;
    return this.http.get<PaginatedAuditResponse>(url, { headers: { localTimeZone }, params: params });
  }

  searchAuditExport(filters: AuditFilter, localTimeZone: string): Observable<AuditExportResponse> {
    const filteredParams = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value != null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as any);

    const url = `${environment.backOfficeUrl}${serviceUris.searchAuditExportList}`;
    return this.http.get<AuditExportResponse>(url, { headers: { localTimeZone }, params: filteredParams });
  }

  getAuditExportLimit(dealerId: string): Observable<AuditExportLimitResponse> {
    const url = `${environment.backOfficeUrl}${serviceUris.getAuditExportLimit}`;
    return this.http.get<AuditExportLimitResponse>(url, { headers: { dealer: dealerId } });
  }
}
